import { render } from "./Authorization.vue?vue&type=template&id=e9b954be&scoped=true&ts=true"
import script from "./Authorization.vue?vue&type=script&lang=ts"
export * from "./Authorization.vue?vue&type=script&lang=ts"

import "./Authorization.vue?vue&type=style&index=0&id=e9b954be&scoped=true&lang=css"

import exportComponent from "/home/dankoff_shop_admin/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9b954be"]])

export default __exports__